import { format } from 'date-fns';

import type { SelectableItem } from './useMultiselect';

export type MediaObject = SelectableItem & {
  capturedAt: string;
};

/**
 * Groups media objects by their captured date.
 * @param {Object[]} media - An array of media objects with id and createdAt properties.
 * @returns {Object.<string, Object[]>} - An object where keys are capturedAt dates and values are arrays of media objects.
 */

export const mediaByCapturedAt = (
  media: MediaObject[],
): { [key: string]: MediaObject[] } => {
  return media.reduce(
    (
      acc: {
        [key: string]: MediaObject[];
      },
      mediaObject: MediaObject,
    ) => {
      const formattedDate = format(
        new Date(mediaObject.capturedAt),
        'EEEE, LLLL do, yyyy',
      );

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(mediaObject);
      return acc;
    },
    {},
  );
};
